import { combineReducers } from 'redux';

import claimInfo from './claimInfo';

export default combineReducers({
    claimInfo,
})